import { makeStyles } from '@mui/styles'
import { maxWidth, Theme } from '@mui/system'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  tabWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',

      maxWidth: 1044,

      [theme.breakpoints.down('tablet')]: {
        gap: '30px',
      },
      [theme.breakpoints.up('tablet')]: {
        padding: SPACES.xs,

        gap: '40px',
      },
    },
  },

  //* Payment
  cardsWrapper: {
    display: 'flex',

    [theme.breakpoints.down('tablet')]: {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    [theme.breakpoints.up('tablet')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.between('tablet', 'laptop')]: {
      gap: SPACES.xs,
    },
    [theme.breakpoints.up('laptop')]: {
      gap: '30px',
    },
  },
  cardContentWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      alignItems: 'center',
      gap: SPACES.xxxl,
    },
  },
  cardNumberWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      alignItems: 'center',
      gap: SPACES.xs,
    },
  },
  cardDots: {
    [theme.breakpoints.down('tablet')]: {
      fontWeight: FONTS.WEIGHTS.black,
      fontSize: FONTS.SIZES.xxxxl,
      lineHeight: 0.3,
      color: theme.palette.custom.darkBlue2,
    },
  },
  cardPaymentIcon: {
    [theme.breakpoints.down('tablet')]: {
      width: 60,
      height: 40,
    },
  },
  card: {
    '&&': {
      position: 'relative',

      padding: `${SPACES.xxl} 30px 30px`,
      width: 308,
      height: 178,
    },
  },
  cardActive: {
    '&&': {
      border: `2px solid ${theme.palette.custom.primary}`,
      borderRadius: '10px',
    },
  },
  cardIconWrapper: {
    marginBottom: SPACES.s,

    width: 32,
    height: 22,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,

    backgroundColor: theme.palette.custom.secondary,
    cursor: 'pointer',

    '&:hover, &:focus': {
      backgroundColor: theme.palette.custom.primary,
    },

    transition: 'background-color 0.1s linear',
  },
  cardDescription: {
    margin: 0,
    marginBottom: SPACES.xxxs,
    fontWeight: FONTS.WEIGHTS.normal,
    fontSize: '9px',
    lineHeight: 1.33,
    textTransform: 'uppercase',

    color: theme.palette.custom.grey2,
  },
  cardBottomWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardInfo: {
    margin: 0,

    color: theme.palette.custom.darkBlue2,

    [theme.breakpoints.down('tablet')]: {
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.medium,
      lineHeight: 1.4,
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: FONTS.SIZES.m,
      fontWeight: FONTS.WEIGHTS.bold,
      lineHeight: 1.33,
    },
  },
  cardInfoMb: {
    marginBottom: SPACES.l,
  },
  cardChooseCircle: {
    position: 'absolute',
    top: 10,
    right: 10,

    width: 18,
    height: 18,
    border: `1px solid ${theme.palette.custom.grey}`,
    borderRadius: '50%',
  },
  cardChooseIconActive: {
    '&&': {
      border: 0,
    },
  },
  cardChooseIcon: {
    width: 18,
    height: 18,
  },

  //* Settings
  settingsWrapper: {
    marginTop: SPACES.m,
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('tablet')]: {
      gap: SPACES.xl,
    },
    [theme.breakpoints.up('tablet')]: {
      gap: 40,
    },
  },
  settingsLeftWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      alignItems: 'center',
      gap: SPACES.xxl,
    },
  },
  languageWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      alignItems: 'center',
      gap: SPACES.xs,
    },
  },
  settingsIconWrapper: {
    [theme.breakpoints.down('tablet')]: {
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: `0px 2px 10px ${theme.palette.custom.grey}`,
      borderRadius: 10,
    },
  },
  settingsIconWrapperLight: {
    backgroundColor: theme.palette.custom.primary,
  },
  settingsIconWrapperDark: {
    backgroundColor: theme.palette.custom.darkBlue2,
  },
  lightIcon: {
    '&&': {
      color: theme.palette.custom.white,
      fill: theme.palette.custom.white,
    },
  },
  greyIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      fill: theme.palette.custom.grey2,
    },
  },
  settingsTitle: {
    [theme.breakpoints.down('tablet')]: {
      margin: 0,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  settingsTitleDark: {
    [theme.breakpoints.down('tablet')]: {
      color: theme.palette.custom.darkBlue2,
    },
  },
  settingsTitleGrey: {
    [theme.breakpoints.down('tablet')]: {
      color: theme.palette.custom.grey2,
    },
  },
  settingsBottomWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,

    width: '100%',
  },
  settingsItemsWrapper: {
    display: 'flex',
    gap: 40,
    width: '100%',
  },
  settingsItemWrapper: {
    width: '100%',

    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    [theme.breakpoints.up('tablet')]: {
      padding: '40px',
    },
  },
  settingsItemInerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    rowGap: '30px',
    flexWrap: 'wrap',
  },
  notificationsWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(2, auto)',
    columnGap: 110,
    rowGap: 30,
  },
  notificationsSwitchWrapper: {
    maxWidth: '214px',
  },
  settingsItems: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '40px',
    width: '100%',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
  },
  settingsItem: {
    // maxWidth: '362px',
    width: '100%',
    maxWidth: '100%',
    // height: '30px',
    // cursor: 'pointer',

    [theme.breakpoints.down('tablet')]: {
      height: 'fit-content',
    },
  },
  settingsActionWrapper: {
    width: 'calc(50% - 20px)',
  },

  //* Cancellation
  cancellationWrapper: {
    display: 'flex',

    [theme.breakpoints.down('tablet')]: {
      flexDirection: 'column',
      gap: SPACES.s,
    },
    [theme.breakpoints.up('tablet')]: {
      justifyContent: 'space-between',
    },
  },
  cancellationButton: {
    '&&': {
      borderRadius: '20px',

      fontSize: FONTS.SIZES.s,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,

      '&:disabled': {
        backgroundColor: theme.palette.custom.secondary,
        color: theme.palette.custom.darkBlue2,
      },

      width: 200,
      height: 40,

      [theme.breakpoints.down('tablet')]: {
        marginLeft: 'auto',
      },
    },
  },
  cancellationButtonRed: {
    '&&': {
      backgroundColor: theme.palette.custom.warning2,

      '&:hover, &:focus': {
        backgroundColor: '#d9434b',
      },
    },
  },
  cancellationButtonGreen: {
    '&&': {},
  },

  //* Common
  itemUpperWrapper: {
    marginBottom: SPACES.m,

    display: 'flex',
    justifyContent: 'space-between',
    gap: SPACES.xxxs,
  },
  itemButton: {
    '&&': {
      borderRadius: 10,
      backgroundColor: theme.palette.custom.grey,

      color: theme.palette.custom.darkBlue2,
      textTransform: 'none',

      // [theme.breakpoints.up('tablet')]: {
      height: 40,
      // },

      '&:hover, &:focus': {
        backgroundColor: theme.palette.custom.grey,
      },
    },
  },
  itemBorder: {
    border: `1px solid ${theme.palette.custom.grey}`,

    [theme.breakpoints.down('tablet')]: {
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl} ${SPACES.xxl}`,
      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      padding: `40px`,
      borderRadius: 15,
    },
  },
  itemTitle: {
    margin: 0,
    position: 'relative',
    alignSelf: 'start',

    [theme.breakpoints.down('tablet')]: {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  itemTitleMb: {
    '&&': {
      marginBottom: SPACES.xl,
    },
  },

  itemSubtitle: {
    margin: 0,
    marginBottom: '5px',

    [theme.breakpoints.down('tablet')]: {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.default,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },

  dropdownIcon: {
    width: 10,
    height: 16,
  },
  switchWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  switchLabel: {
    margin: 0,
    display: 'flex',
    gap: SPACES.xs,
    alignItems: 'center',
  },
  switchLabelText: {
    margin: 0,

    fontSize: '14px',
    lineHeight: 1.34,

    color: theme.palette.custom.darkBlue2,

    [theme.breakpoints.down('mobile_l')]: {
      fontSize: '12px',
    },
  },
  modalWrapper: {
    minHeight: 360,
    [theme.breakpoints.down('tablet')]: {
      width: '100vw',
      maxWidth: '400px',
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: SPACES.xxl,
  },
}))

export { useStyles }
